module.exports = __webpack_public_path__ + "static/media/eng.b329014d.png";